import axios from "axios";
import {
  PROMOTIONS_URL,
  WHATSAPP_MESSAGE_TRIGGER_URL,
  REGISTER_CUSTOMER_ON_WHATSAPP_URL,
  SALE_ORDER_INVOICE_SMS_URL,
} from "../../../../../constants/config";

//call api to fetch customers
export function findPromotions(queryParams) {
    return axios.get(
        `${PROMOTIONS_URL}/list?search_key=${queryParams?.searchKey || ""}&statuses=${queryParams?.statuses || 1}&page=${queryParams.pageNumber || 1
        }&page_size=${queryParams.pageSize || 20}&sort_by=${queryParams.sort_by || "updated_at:desc"}`
    );
}

export function createPromotion(promotion) {
    return axios.post(`${PROMOTIONS_URL}`, promotion);
}

export function getPromotionById(id) {
    return axios.get(`${PROMOTIONS_URL}/${id}`);
}

export function updatePromotion(id, promotion) {
    return axios.put(`${PROMOTIONS_URL}/${id}`, promotion);
}

export function deletePromotion(id) {
    return axios.delete(`${PROMOTIONS_URL}/${id}`);
}

export function updatePromotionEnabled(id, is_enabled) {
    return axios.patch(`${PROMOTIONS_URL}/${id}/enabled`, { is_enabled });
}

export function exportPromotionInsights(promotionId, filters = {}) {
    return axios.post(`${PROMOTIONS_URL}/${promotionId}/insights/export`, filters);
}

// Registed Customer with WhatsApp Services
export function registerCustomerWithWhatsApp(body){
    return axios.post(`${REGISTER_CUSTOMER_ON_WHATSAPP_URL}`, body);
}

// Send Invoice on WhatsApp Message: Message Trigger on WhatsApp
export function sendInvoiceOnWhatsAppMessage(body){
    return axios.post(`${WHATSAPP_MESSAGE_TRIGGER_URL}`, body);
}

// Send Invoice on SMS: Message Trigger on SMS
export function sendInvoiceOnSmsMessage(body) {
  return axios.post(`${SALE_ORDER_INVOICE_SMS_URL}`, body);
}
